import { useEffect } from "react";
import Lenis from "lenis";
import "@/index.css";
import Navbar from "@/components/Navbar";
import CentralStatusBanner from "@/components/CentralStatusBanner";
import Hero from "@/components/Hero";
import Plans from "@/components/Plans";
import Coverage from "@/components/Coverage";
import Differentials from "@/components/Differentials";
import Testimonials from "@/components/Testimonials";
import Support from "@/components/Support";
import Faq from "@/components/Faq";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="overflow-x-clip bg-ink font-body text-white">
      <div className="noise" aria-hidden="true" />
      <CentralStatusBanner />
      <Navbar />
      <main>
        <Hero />
        <Plans />
        <Coverage />
        <Differentials />
        <Testimonials />
        <Support />
        <Faq />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
